module.exports = __webpack_public_path__ + "static/media/defaultAvatar19.fd085e89.svg";